var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('text-input',{attrs:{"value":_vm.value},on:{"changed":_vm.onChanged}},[_c('base-material-icon',{staticClass:"icon-preview",attrs:{"icon-name":_vm.value}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }